import { render } from "./harvesterhci.io.virtualmachinebackup.vue?vue&type=template&id=2fde9096"
import script from "./harvesterhci.io.virtualmachinebackup.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.virtualmachinebackup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__